/* global console, document, Office */
import LogHelper from "./logHelper";
import Themes from "./../global/themes";
import { loadSettings, saveSetting } from "./settings";
import { handleFiles, readCSVFiles } from "./fileHandler";
import QuickBooks from "./quickBooks?v=3";
import { getSheetData, validationQBOPostData } from "./excelUtils";
import constants from './constants?v=3';

const logHelper = new LogHelper();
const quickBooks = new QuickBooks();

// The initialize function must be run each time a new page is loaded
Office.onReady(async () => {
  let info = await Office.onReady();
  if (info.host !== Office.HostType.Excel) {
    return false;
  }
  const themes = new Themes();
  themes.loadAppTheme();
  MacWebNotice();
  try {
    await JSVBAInterface.healthCheckStartup();
    document.getElementById('WrongWorkbook').classList.add("hide");
  } catch (error) {
    document.getElementById('wrong-workbook-text').textContent = error.message;
  }

  document.getElementById("app-body").classList.remove("hide");
  const fileList = document.getElementById('fileList');
  const dropArea = document.getElementById('dropArea');
  const fileInput = document.getElementById('fileInput');
  const processFileBtn = document.getElementById('processBtn');

  // Global variable
  window.saleImportSheet = null;

  fileInput.addEventListener('change', handleFiles);
  processFileBtn.addEventListener('click', readCSVFiles);

  dropArea.addEventListener('dragover', (event) => {
    event.preventDefault();
    dropArea.classList.add('dragover');
  });

  dropArea.addEventListener('dragleave', () => {
    dropArea.classList.remove('dragover');
  });

  dropArea.addEventListener('drop', (event) => {
    event.preventDefault();
    dropArea.classList.remove('dragover');
    handleFiles(event);
  });


  if (!Office.context.document.settings.get("Office.AutoShowTaskpaneWithDocument") &&
    location.hostname === "excel.engineering") {
    Office.context.document.settings.set("Office.AutoShowTaskpaneWithDocument", true);
    Office.context.document.settings.saveAsync();
  }

  // Load settings and attach event listeners
  loadSettings();
  setupSettingsListeners();
});

function setupSettingsListeners() {
  const filesystemSelect = document.getElementById('filesystemSelect');
  const qboUploadCheckbox = document.getElementById('qboUploadCheckbox');
  const testFilesystemBtn = document.getElementById('testFilesystemBtn');
  const logoutQBOBtn = document.getElementById('logoutQBOBtn');
  const loginQBOBtn = document.getElementById('loginQBOBtn');
  // const postJournalOnQboBtn = document.getElementById('postJournalDataOnQBO');


  filesystemSelect.addEventListener('change', () => {
    saveSetting('filesystemOption', filesystemSelect.value);
  });

  qboUploadCheckbox.addEventListener('change', () => {
    const isChecked = qboUploadCheckbox.checked;
    saveSetting('qboUploadEnabled', isChecked.toString());
    loginQBOBtn.classList.toggle('hide', !isChecked);
    if (!isChecked) {
      document.getElementById("QBOAuthenticationMsg").classList.add("hide");
      document.getElementById("QBOUserInfo").classList.add("hide");
      logoutQBOBtn.classList.add("hide");
    }
    else {
      quickBooks.getUserAndCompanyInfo();
    }
  });

  testFilesystemBtn.addEventListener('click', async () => {
    const originalText = testFilesystemBtn.textContent;
    const originalClasses = testFilesystemBtn.className;
    testFilesystemBtn.textContent = 'Checking connection...';
    testFilesystemBtn.classList.add('pending');
    testFilesystemBtn.disabled = true;

    let requestsData = [{ request: "ConnectionCheck" }];
    try {
      const responses = await submitAndAwaitRequests(requestsData);
      const response = responses[0];
      testFilesystemBtn.textContent = response.status === 'Complete' ? (response.response || 'Connection successful!') : 'Connection failed.';
      testFilesystemBtn.classList.remove('pending');
      testFilesystemBtn.classList.add(response.status === 'Complete' ? 'success' : 'failure');
    } catch (error) {
      testFilesystemBtn.textContent = 'Connection failed.';
      testFilesystemBtn.classList.remove('pending');
      testFilesystemBtn.classList.add('failure');
    } finally {
      setTimeout(() => {
        testFilesystemBtn.textContent = originalText;
        testFilesystemBtn.className = originalClasses;
        testFilesystemBtn.disabled = false;
      }, 2000);
    }
  });

  loginQBOBtn.addEventListener('click', async () => {
    if (qboUploadCheckbox.checked) {
      await logHelper.writeLog(logHelper.LogTypes.Msg, 'Testing QBO connection...');
      quickBooks.CheckAuthentication();
    } else {
      await logHelper.writeLog(logHelper.LogTypes.Warn, 'QBO upload is not enabled.');
    }
  });

  logoutQBOBtn.addEventListener('click', async () => {
    if (qboUploadCheckbox.checked) {
      await logHelper.writeLog(logHelper.LogTypes.Msg, 'Clearing QBO connections...');
      Office.context.document.settings.remove(constants.SettingKeys.QBOToken);
      Office.context.document.settings.remove(constants.SettingKeys.QBOUserInfo);
      Office.context.document.settings.remove(constants.SettingKeys.QBOCompanyInfo);
      Office.context.document.settings.remove(constants.SettingKeys.QBOClassList);
      Office.context.document.settings.remove(constants.SettingKeys.QBOAccounts);
      await Office.context.document.settings.saveAsync();
      document.getElementById("QBOUserInfo").classList.add("hide");
      document.getElementById("QBOAuthenticationMsg").classList.add("hide");
      logoutQBOBtn.classList.add("hide");
      loginQBOBtn.classList.remove("hide");
      await logHelper.writeLog(logHelper.LogTypes.Msg, 'Cleaned QBO connections & setting entries.');
    } else {
      await logHelper.writeLog(logHelper.LogTypes.Warn, 'QBO upload is not enabled.');
    }
  });
  // postJournalOnQboBtn.addEventListener('click', async () => {
  //   if (qboUploadCheckbox.checked) {
  //     pushJournalEntryDataToQBO();
  //   }
  // });
}
function MacWebNotice() {
  // Check if the platform is Mac
  const isMac = Office.context.platform === Office.PlatformType.Mac;

  // Check if the host is Excel and running in the web context
  const isExcelWeb = Office.context.diagnostics.platform === Office.PlatformType.OfficeOnline;

  if (isMac && isExcelWeb) {
  }
  else {
    document.getElementById("MacWebMsg").classList.add("hide");
  }
}

async function pushJournalEntryDataToQBO(params) {
  const sheetData = await getSheetData();
  console.log("Sheet data", sheetData);
  if (sheetData && sheetData.data.length > 0) {
    // quickBooks.pushJournalEntryOnQbo(sheetData.data);
    let filename = "{Sales Entry Form} Financial View (3).csv";
    const result = await quickBooks.pushJournalEntryOnQbo(sheetData.data);
    if (result && result.ok === true) {
      let isAnyError = false;
      if (result.data && result.data.BatchItemResponse.length > 0) {
        {
          for (let i = 0; i < result.data.BatchItemResponse.length; i++) {
            const entry = result.data.BatchItemResponse[i];
            if (entry.Fault) {
              isAnyError = true;
              let journalEntryID = (entry.bId).split("#")[1];
              for (let j = 0; j < entry.Fault.Error.length; j++) {
                const errorInfo = entry.Fault.Error[j];
                await logHelper.writeLog(logHelper.LogTypes.Error, `Error in pushing data for journal entry ID:${journalEntryID}. Error Type:${entry.Fault.type} | Error Detail:${errorInfo.Detail} | Error Message:${errorInfo.Message} | Error Code:${errorInfo.code}`);
              }
            } else {
              await logHelper.writeLog(logHelper.LogTypes.Msg, `Data pushed successfully for entry ${i + 1}`);
            }
          }
        }
        if (isAnyError) {
          validationQBOPostData(true, filename);
          await logHelper.writeLog(logHelper.LogTypes.Error, `Some errors occurred while pushing data to QBO. Please check the logs for details.`);
        } else {
          validationQBOPostData(false, filename);
          await logHelper.writeLog(logHelper.LogTypes.Msg, `Data pushed successfully to QBO for file: ${filename}`);
        }
      } else {
        await logHelper.writeLog(logHelper.LogTypes.Error, `Failed to push data to QBO for file: ${filename}`);
      }
    }
  }
}